export default __webpack_public_path__ + "static/media/DSC_0520.a9b10033.webp";